export function getPhoneFormatted(value: string): string {
  const parseValue = String(value);

  if (!parseValue || String(parseValue).trim().length !== 11) return '';

  let phone = `(${parseValue.substring(0, 2)}) `;
  phone += `${parseValue.substring(2, 7)}-`;
  phone += `${parseValue.substring(7)}`;

  return phone;
}

export function getChunkPhoneFormatted(value: string): string {
  let phone = `(${value.substring(0, 2)}) `;
  phone += `${value.substring(2, 7)}`;
  if (value.length > 7) {
    phone += '-';
  }
  if (value.length > 8) {
    phone += `${value.substring(7)}`;
  }

  return phone;
}

export function formatPhone(value: string): string {
  const phone = value;
  if (phone.length === 1) return `(${value}`;
  if (phone.length === 3) return `${value}) `;
  if (phone.length === 3) return `${value}) `;

  return '';
}

export function clearFormatPhoneNumber(value: string): string {
  let phone = value.replaceAll('(', '');
  phone = phone.replaceAll(')', '');
  phone = phone.replaceAll('-', '');
  phone = phone.replaceAll(' ', '');
  
  // Remove o 9 extra se existir (para números de celular brasileiros)
  if (phone.length > 10 && phone[2] === '9') {
    phone = phone.substring(0, 2) + phone.substring(3);
  }
  
  return phone.trim();
}
